module.exports = __webpack_public_path__ + "img/16523561.b5b79419.png";